<div class="modal is-active">
  <div class="modal-background" (click)="onCloseModal()"></div>
  <div class="modal-content">
    <div class="box">
      <h1 class="title">Asignar ejecutor</h1>
      
      <div class="tasks-container">
        <table class="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Tareas</th>
              <th>Ejecutor</th>
            </tr>
          </thead>
          <tbody>
            @for(group of phaseGroups; track group.phaseId){
              <tr class="phase-header">
                <td colspan="2">
                  <span class="phase-name">Fase {{ group.phaseNumber }} {{ group.phaseName }}</span>
                </td>
              </tr>
              @for(task of group.tasks; track task.id){
                <tr>
                  <td class="task-name">{{ task.name }}</td>
                  <td class="executor-cell">
                    <p-dropdown
                      [options]="executors"
                      [(ngModel)]="taskExecutors[task.id]"
                      optionValue="id"
                      optionLabel="name"
                      placeholder="Seleccionar ejecutor"
                      [showClear]="false"
                      [emptyFilterMessage]="'No se encontraron resultados'"
                      styleClass="executor-dropdown"
                      [scrollHeight]="'250px'"
                      appendTo="body"
                    />
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="buttons-container">
        <button class="button is-outlined cancel-button" (click)="onCloseModal()">
          Cancelar
        </button>
        <button class="button save-button" (click)="onSave()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

